import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {SuppliersListFilter} from './SuppliersListFilter'

const SuppliersListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddSupplierModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-supplier-table-toolbar='base'>
      <SuppliersListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add supplier */}
      <button type='button' className='btn btn-primary' onClick={openAddSupplierModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='SUPPLIER.TABLE.CREATESUPPLIER' />
      </button>
      {/* end::Add supplier */}
    </div>
  )
}

export {SuppliersListToolbar}
